var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ru:admin-card",class:_vm.tight ? '--tight' : ''},[_c('Box',{attrs:{"background":"white","border":"iron"}},[(_vm.title)?_c('Headline',{attrs:{"level":3}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }